import { queryGet, queryPost, queryPut } from '@/api/apiConfig';

export default {
  saveDesign (projectData) {
    return queryPost('/api/app/design/', projectData);
  },

  updateDesign (designedJacketId, projectData) {
    return queryPut(`/api/app/design?designedJacketId=${designedJacketId}`, projectData);
  },

  loadDesign (designedJacketId) {
    return queryGet(`/api/app/design?designedJacketId=${designedJacketId}`);
  },

  saveJacketDesignForSchool (data) {
    return queryPost('/api/app/design/template', data);
  },

  updateJacketDesign (designedJacketId, projectData) {
    return queryPut(`/api/app/design/template/${designedJacketId}`, projectData);
  },
};
